// OCC_Website/src/hooks/useTalentSelection.js
import { useState, useCallback } from 'react';

const useTalentSelection = () => {
    const [selectedIds, setSelectedIds] = useState([]);

    const handleSelectionChange = useCallback((id, isSelected) => {
        setSelectedIds((prevSelectedIds) => {
            if (isSelected) {
                return [...prevSelectedIds, id];
            } else {
                return prevSelectedIds.filter((prevId) => prevId !== id);
            }
        });
    }, []);

    const resetSelection = useCallback(() => {
        setSelectedIds([]);
    }, []);

    return {
        selectedIds,
        handleSelectionChange,
        resetSelection,
    };
};

export default useTalentSelection;
